import type {LoginButtonColor, LoginButtonSize} from '@yandex-delivery/blocks'
import {Loader, PassportUser, useTransition} from '@yandex-delivery/blocks'
import React from 'react'

import {fetchAllAccountsDeprecated} from '../../api'
import {appConfig, i18n} from '../../config'

type UserProps = {
  isMobile?: boolean
  size?: LoginButtonSize
  color?: LoginButtonColor
}

function User({isMobile = false, size, color}: UserProps): React.ReactElement<UserProps> | null {
  const [{payload, isPending}] = useTransition(fetchAllAccountsDeprecated, {
    key: 'fetch/accounts',
  })

  if (isPending) {
    return <Loader size="m" />
  }

  if (payload) {
    return (
      <PassportUser
        addUserText={i18n('passport.user.adduser', 'Добавить пользователя')}
        avatarHost={appConfig.avatarsHost}
        color={color}
        mobile={isMobile}
        passport={payload}
        passportHost={appConfig.passportHost}
        returnPath={encodeURIComponent(window.location.href)}
        signInText={i18n('passport.user.signin', 'Войти')}
        signOutText={i18n('passport.user.signout', 'Выйти')}
        size={size}
        yui={appConfig.yandexuid}
      />
    )
  }

  return null
}

export default React.memo(User) as typeof User
